import React from 'react';
import clsx from 'clsx';
import { formatCalendarDate } from '@utils/dateUtils';
import { kebabToCamelCase } from '@utils/stringUtils';
import styles from './SchedulerTableCells.module.css';

const TargetDateCell: React.FC<{
  urgency: string | undefined;
  targetDate: string | undefined;
}> = ({ urgency, targetDate }) => {
  const getTargetDateColor = (urgency: string | undefined, targetDate: string | undefined) => {
    if (urgency) {
      switch (urgency) {
        case 'critical':
          return 'urgency-critical';
        case 'late':
          return 'urgency-late';
        case 'ready':
          return 'urgency-ready';
        default:
          return 'urgency-none';
      }
    }

    if (!targetDate) {
      return 'urgency-none';
    }

    const target = new Date(targetDate);
    const today = new Date();
    const daysUntilTarget = Math.ceil((target.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));

    if (daysUntilTarget <= 10) {
      return 'urgency-critical';
    } else if (daysUntilTarget <= 30) {
      return 'urgency-late';
    } else if (daysUntilTarget <= 60) {
      return 'urgency-ready';
    } else {
      return 'urgency-future';
    }
  };

  const targetDateColorClass = getTargetDateColor(urgency, targetDate);
  const urgencyClassKey = targetDateColorClass ? (kebabToCamelCase(targetDateColorClass) as keyof typeof styles) : null;

  return (
    <div className={styles.targetDateCell}>
      <span className={styles.targetDateText}>
        {targetDate ? (
          <span className={clsx(styles.targetDate, urgencyClassKey && styles[urgencyClassKey])}>
            {formatCalendarDate(targetDate)}
          </span>
        ) : (
          <span className={styles.noDate}>Not set</span>
        )}
      </span>
    </div>
  );
};

export default TargetDateCell;
